<div class="toast-container">
    @for (toast of toastService.toasts(); track toast.id) {
    <div class="toast toast-{{ toast.type }}" [class.exiting]="toast.exiting">
        <!-- Font Awesome Icons -->
        <span class="toast-icon">
            @switch (toast.type) {
            @case ('success') { <i class="fa-solid fa-circle-check"></i> }
            @case ('error') { <i class="fa-solid fa-circle-xmark"></i> }
            @case ('warning') { <i class="fa-solid fa-triangle-exclamation"></i> }
            @default { <i class="fa-solid fa-circle-info"></i> }
            }
        </span>

        <span class="toast-text">{{ toast.message }}</span>

        <button class="toast-close" (click)="toastService.dismiss(toast.id)">×</button>
    </div>
    }
</div>